import { useState } from 'react'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { Label } from '@/components/ui/label'
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group'
import { Platform } from '@/types'

interface PlatformConfirmDialogProps {
  open: boolean
  suggestedPlatform: Platform | null
  confidence: number
  onConfirm: (platform: Platform) => void
  onCancel: () => void
}

const PLATFORMS: { value: Platform; label: string }[] = [
  { value: 'bolt', label: 'Bolt' },
  { value: 'uber', label: 'Uber' },
  { value: 'sumup', label: 'SumUp' },
  { value: 'other', label: 'Annan' }
]

export function PlatformConfirmDialog({
  open,
  suggestedPlatform,
  confidence,
  onConfirm,
  onCancel
}: PlatformConfirmDialogProps) {
  const [selectedPlatform, setSelectedPlatform] = useState<Platform>(
    suggestedPlatform || 'bolt'
  )

  const handleConfirm = () => {
    onConfirm(selectedPlatform)
  }

  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onCancel()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Välj plattform</DialogTitle>
          <DialogDescription>
            {confidence > 0 ? (
              <>
                Vi kunde inte automatiskt identifiera plattformen med hög säkerhet
                ({Math.round(confidence)}% säkerhet).
                Vänligen bekräfta vilken plattform filen kommer från.
              </>
            ) : (
              <>
                Vi kunde inte identifiera vilken plattform filen kommer från.
                Vänligen välj rätt plattform.
              </>
            )}
          </DialogDescription>
        </DialogHeader>

        <div className="py-4">
          <RadioGroup
            value={selectedPlatform}
            onValueChange={(value) => setSelectedPlatform(value as Platform)}
            className="space-y-3"
          >
            {PLATFORMS.map((platform) => (
              <div key={platform.value} className="flex items-center space-x-3">
                <RadioGroupItem value={platform.value} id={platform.value} />
                <Label
                  htmlFor={platform.value}
                  className="cursor-pointer font-normal"
                >
                  {platform.label}
                  {platform.value === suggestedPlatform && confidence > 0 && (
                    <span className="text-muted-foreground ml-2">
                      (föreslaget)
                    </span>
                  )}
                </Label>
              </div>
            ))}
          </RadioGroup>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={onCancel}>
            Avbryt
          </Button>
          <Button onClick={handleConfirm}>
            Bekräfta
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
